export const DATE_FORMAT = 'd MMMM, yyyy';
export const EXPIRE_DATE_FORMAT = 'dd.MM.yyyy';
